const ServiceIcon1 = () => {
    return (
        <div>
            <svg width="30" height="30" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.38585 1.64497C5.84859 4.57716 6.22276 7.70179 7.66037 10.5728L7.66037 10.5728C11.0816 17.4048 19.2547 20.2854 26.1655 17.2133C25.0447 20.2673 22.8054 22.9159 19.6683 24.4869C13.1307 27.7607 5.17717 25.1146 1.90342 18.5771C-1.11982 12.5394 0.908085 5.29613 6.38585 1.64497Z" fill="white" stroke="#232323"/>
            </svg>
        </div>
    );
};

export default ServiceIcon1;
